module.exports = __webpack_public_path__ + "img/tags.74cf2fc1.png";